import { call, put, takeLatest } from 'redux-saga/effects';
import { push } from 'react-router-redux';
import swal from 'sweetalert';
import api from 'services/api';
import moment from 'moment';

import { Creators as EventsActions, Types as EventsTypes } from 'store/ducks/events';

function* getEventRequest(action) {
  try {
    const { id } = action.payload;
    const url = `feed/v2/events/${id}`;
    const response = yield call(api.get, url);

    yield put(EventsActions.getEventSuccess(response.data));
  } catch (error) {
    yield put(EventsActions.getEventFailure());
  }
}

function* getEventsRequest(action) {
  try {
    const { page, filters } = action.payload;
    let filter = '';

    if (filters !== null) {
      const local_id = filters.local.value !== '' ? `&local_id=${filters.local.value}` : '';
      const date_start_at =
        filters.start_at !== null ? `&date_start_at=${moment(filters.start_at).format('YYYY-MM-DD')}` : '';
      const date_end_at = filters.end_at !== null ? `&date_end_at=${moment(filters.end_at).format('YYYY-MM-DD')}` : '';
      const status = filters.status.value !== '' ? `&status=${filters.status.value}` : '';

      filter = `${local_id}${date_start_at}${date_end_at}${status}`;
    }

    const url = `feed/v2/events?page=${page}&per=25${filter}&order_date=DESC`;
    const response = yield call(api.get, url);

    yield put(EventsActions.getEventsSuccess(response.data));
  } catch (error) {
    yield put(EventsActions.getEventsFailure());
  }
}

function* createEventRequest(action) {
  try {
    const { data } = action.payload;
    const url = `feed/v2/events`;
    const response = yield call(api.post, url, data);

    yield put(push('/events/list'));
    yield call(swal, 'Adicionado', 'Novo evento adicionado', 'success');
    yield put(EventsActions.createEventSuccess(response.data));
  } catch (error) {
    yield call(swal, 'Falha ao Adicionar', 'Não possível criar o evento', 'error');
    yield put(EventsActions.createEventFailure());
  }
}

function* updateEventRequest(action) {
  try {
    const { id, data } = action.payload;
    const url = `feed/v2/events/${id}`;
    const response = yield call(api.put, url, data);

    yield put(push('/events/list'));
    yield call(swal, 'Atualizado', 'Evento atualizado com sucesso', 'success');
    yield put(EventsActions.updateEventSuccess(response.data));
  } catch (error) {
    yield call(swal, 'Falha ao atualizar', 'Não foi possível atualizar evento', 'error');
    yield put(EventsActions.updateEventFailure());
  }
}

export function* getEventsLocalRequest(action) {
  try {
    const { query } = action.payload;
    const url = `feed/locals?search=${query}`;
    const response = yield call(api.get, url);
    yield put(EventsActions.getEventsLocalSuccess(response.data));
  } catch (error) {
    yield put(EventsActions.getEventsLocalFailure('Não foi possível carregar os locais'));
  }
}

function* getEventStoresRequest(action) {
  try {
    const { query } = action.payload;
    const url = `store/v2/places?search=${query}`;
    const response = yield call(api.get, url);

    yield put(EventsActions.getEventStoresSuccess(response.data));
  } catch (error) {
    yield put(EventsActions.getEventStoresFailure());
  }
}

export function* getEventsTypesRequest() {
  try {
    const url = 'feed/types';
    const response = yield call(api.get, url);
    yield put(EventsActions.getEventsTypesSuccess(response.data));
  } catch (error) {
    yield put(EventsActions.getEventsTypesFailure('Não foi possível carregar os tipos'));
  }
}

function* getEventPassionsRequest(action) {
  try {
    const { query } = action.payload;
    const url = `classification/v2/passions?search=${query}`;
    const response = yield call(api.get, url);

    yield put(EventsActions.getEventPassionsSuccess(response.data));
  } catch (error) {
    yield put(EventsActions.getEventPassionsFailure());
  }
}

function* getEventDifficultiesRequest(action) {
  try {
    const { query } = action.payload;
    const url = `feed/v2/difficulties?search=${query}`;
    const response = yield call(api.get, url);


    yield put(EventsActions.getEventDifficultiesSuccess(response.data));
  } catch (error) {
    yield put(EventsActions.getEventDifficultiesFailure());
  }
}

function* getEventsPlansRequest(action) {
  try {
    const url = "experience/v2/plans?page=1&per=100&gives_points_value=true";
    const response = yield call(api.get, url);

    yield put(EventsActions.getEventsPlansSuccess(response.data));
  } catch (error) {
    yield put(EventsActions.getEventsPlansFailure());
  }
}

function* approveEventRequest(action) {
  try {
    const { id } = action.payload;
    const url = `feed/v2/events/${id}/approve`;
    yield call(api.post, url);

    yield put(push('/events/list'));
    yield call(swal, 'Aprovado', 'Evento aprovado com sucesso!', 'success');
    yield put(EventsActions.approveEventSuccess());
  } catch (error) {
    yield call(swal, 'Falha ao aprovar', 'Não foi possível aprovar o evento.', 'error');
    yield put(EventsActions.approveEventFailure());
  }
}

function* repproveEventRequest(action) {
  try {
    const { id, data } = action.payload;
    const url = `feed/v2/events/${id}/reprove`;
    yield call(api.post, url, data);

    yield put(push('/events/list'));
    yield call(swal, 'Reprovado', 'Evento reprovado com sucesso!', 'success');
    yield put(EventsActions.repproveEventSuccess());
  } catch (error) {
    yield call(swal, 'Falha ao reprovar', 'Não foi possível reprovar o evento.', 'error');
    yield put(EventsActions.repproveEventFailure());
  }
}

function* inviteEventRequest(action) {
  try {
    const { id, data } = action.payload;
    const url = `feed/v2/events/${id}/invite`;
    yield call(api.post, url, data);

    yield put(push(`/events/${id}/edit`));
    yield call(swal, 'Enviado', 'Convites enviados com sucesso!', 'success');
    yield put(EventsActions.inviteEventSuccess());
  } catch (error) {
    yield call(swal, 'Falha ao enviar', 'Não foi possível enviad convites do evento.', 'error');
    yield put(EventsActions.inviteEventFailure());
  }
}

// function* deleteEventRequest(action) {
//   try {
//     const { id } = action.payload;
//     const url = `feed/v2/events/${id}`;
//     yield call(api.delete, url)

//     yield put(push('/events'));
//     yield call(swal, 'Deletado', 'Evento deletado com sucesso', 'success', 'error');
//     yield put(EventsActions.deleteEventSuccess());
//   } catch (error) {
//     yield call(swal, 'Falha ao atualizar', 'Não foi possível excluir evento', 'error')
//     yield put(EventsActions.deleteEventFailure());
//   }
// }

export default function* sagaEvents() {
  yield takeLatest(EventsTypes.GET_REQUEST, getEventRequest);
  yield takeLatest(EventsTypes.GET_LIST_REQUEST, getEventsRequest);
  yield takeLatest(EventsTypes.CREATE_REQUEST, createEventRequest);
  yield takeLatest(EventsTypes.GET_STORES_REQUEST, getEventStoresRequest);
  yield takeLatest(EventsTypes.UPDATE_REQUEST, updateEventRequest);
  yield takeLatest(EventsTypes.GET_LOCAL_REQUEST, getEventsLocalRequest);
  yield takeLatest(EventsTypes.GET_TYPES_REQUEST, getEventsTypesRequest);
  yield takeLatest(EventsTypes.GET_PASSIONS_REQUEST, getEventPassionsRequest);
  yield takeLatest(EventsTypes.GET_DIFFICULTIES_REQUEST, getEventDifficultiesRequest);
  yield takeLatest(EventsTypes.GET_PLANS_REQUEST, getEventsPlansRequest);
  yield takeLatest(EventsTypes.APPROVE_REQUEST, approveEventRequest);
  yield takeLatest(EventsTypes.REPPROVE_REQUEST, repproveEventRequest);
  yield takeLatest(EventsTypes.INVITE_REQUEST, inviteEventRequest);
}
